"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssessmentType = void 0;
exports.getAssessmentTypes = getAssessmentTypes;
exports.getAssessmentTypeFrom = getAssessmentTypeFrom;
var AssessmentType;
(function (AssessmentType) {
    AssessmentType["Assessment"] = "assessment";
    AssessmentType["Diagnostic"] = "diagnostic";
    AssessmentType["Practice"] = "practice";
    AssessmentType["Handout"] = "handout";
    AssessmentType["Journal"] = "journal";
    AssessmentType["Vocabulary"] = "vocabulary";
})(AssessmentType || (exports.AssessmentType = AssessmentType = {}));
function getAssessmentTypes() {
    return Object.values(AssessmentType);
}
function getAssessmentTypeFrom(value) {
    return getAssessmentTypes().find(function (type) { return type === value; });
}
